import React from 'react';
import TermlyEmbed from './TermlyEmbed';

const CookiePolicy = () => {
  return <TermlyEmbed dataId="59ae13a1-ca7e-47b5-89d3-851fb86fff8c" />;
};

export default CookiePolicy;
